import { render, staticRenderFns } from "./SkupStavkaDetails.vue?vue&type=template&id=b66bb358&scoped=true&"
import script from "./SkupStavkaDetails.vue?vue&type=script&lang=js&"
export * from "./SkupStavkaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66bb358",
  null
  
)

export default component.exports